/* eslint-disable react/no-unescaped-entities */
import { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import ForgetPasswordModal from './../../components/auth/ForgetPasswordModal';
import loginImg from './../../assets/images/emma-bg.png';
import loginImgSmall from './../../assets/images/emma-bg-small.png';
import './../../assets/scss/custom/Login.scss';
import { LoginRequest } from '../../features/Auth/AuthSlice';
import { loaderActions } from '../../features/Loader/LoaderSlice';

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [user, setUser] = useState({
    username: '',
    password: ''
  });

  const { username, password } = user;

  const onChange = (e) => setUser({ ...user, [e.target.name]: e.target.value }); // replace the typed text as value

  const onSubmit = async (e) => {
    e.preventDefault();
    if (username.trim() === '' || password.trim() === '') {
      toast.error('Please fill in all fields', { id: 'error' });
    } else {
      dispatch(loaderActions.show());
      await dispatch(
        LoginRequest({
          username,
          password
        })
      );
      dispatch(loaderActions.hide());
    }
  };

  const bgStyleBig = {
    backgroundImage: `url(${loginImg})`,
    height: '%100',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat'
  };
  const bgStyleSmall = {
    backgroundImage: `url(${loginImgSmall})`,
    height: '%100',
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat'
  };

  const [matches, setMatches] = useState(window.matchMedia('(min-width: 1220px)').matches);

  useEffect(() => {
    window
      .matchMedia('(min-width: 1220px)')
      .addEventListener('change', (e) => setMatches(e.matches));
    dispatch(loaderActions.hide());
  }, []);

  return (
    <>
      <Container fluid className="login-page" style={matches ? bgStyleBig : bgStyleSmall}>
        {isPasswordModalOpen === true && (
          <ForgetPasswordModal setIsOpen={setIsPasswordModalOpen} isOpen={isPasswordModalOpen} />
        )}
        <Row>
          {matches ? <Col className="login-col banner" sm={4}></Col> : null}
          <Col className="login-col form" sm={8}>
            <Form>
              <Form.Group className="align-items-center ">
                <Form.Row className="logo-row mb-5 ml-5">
                  <p className="login-form-header">Welcome to the Emma Vendor Portal</p>
                </Form.Row>
                <Form.Group className="login-form align-items-center  ">
                  <Form.Row>
                    <label className="text-label"> E-mail Address:</label>
                    <Form.Control
                      className="text-normal"
                      size="lg"
                      type="email"
                      name="username"
                      id="username"
                      placeholder="E-mail Address"
                      value={username}
                      onChange={onChange}
                      required
                      autoComplete="email"
                    />
                  </Form.Row>
                  <Form.Row className="mt-4">
                    <label className="text-label"> Password:</label>
                    <Form.Control
                      className="text-normal"
                      size="lg"
                      type="password"
                      name="password"
                      id="password"
                      placeholder="Password"
                      value={password}
                      onChange={onChange}
                      required
                      autoComplete="current-password"
                    />
                  </Form.Row>
                  <Form.Row className="mt-4" color="#1E2B5A">
                    <Button
                      variant="primary"
                      className="btn btn-block text-normal"
                      style={{ backgroundColor: '#1E2B5A', borderRadius: '5px' }}
                      type="submit"
                      onClick={onSubmit}
                      block
                    >
                      Login
                    </Button>
                  </Form.Row>
                  <br />
                  <Form.Row className=" mt-2 " color="#1E2B5A">
                    <p className="mb-0 text-white">
                      Forgot password?{' '}
                      <Button variant="link" onClick={() => [setIsPasswordModalOpen(true)]}>
                        Reset
                      </Button>
                    </p>
                  </Form.Row>
                  <Form.Row className=" mt-2 " color="#1E2B5A">
                    <p className="mb-0 text-white">
                      Don’t have an account?{' '}
                      <Button variant="link" onClick={() => navigate('/signup')}>
                        Signup
                      </Button>
                    </p>
                  </Form.Row>
                </Form.Group>
              </Form.Group>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default LoginPage;
